import {
  EditActionDefinition,
  SystemActionsList,
  EditActionBase as SystemAction,
  SystemActionNames,
  ActionNames,
} from '@wix/editor-platform-host-integration-apis';
import { PlatformContext } from '../types';
import { EditActionsStore } from '../editActionsStore';
import { filterByTags, resolveSystemActionsWithFactories } from '../utils';

export const getSystemActions = (
  platformContext: PlatformContext,
  tags?: string[],
): EditActionDefinition<ActionNames>[] => {
  const systemActions = EditActionsStore.getActionsByActionNames(
    Object.values(SystemActionsList),
  ) as SystemAction<SystemActionNames>[];

  return filterByTags(
    resolveSystemActionsWithFactories<SystemAction<SystemActionNames>>(
      systemActions,
      platformContext,
    ),
    tags,
  );
};
